<template>
  <span
    :class="['inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-normal', colorClass]"
  >
    <component :is="icon" class="w-4 h-4 flex-shrink-0" />
    {{ t(`corp.company_switcher.status.${status}`) }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  CheckCircleIcon,
  TimeInputClockIcon,
  InactiveWarningIcon,
  CardBlockedPadlockIcon,
} from '@ecx/ui/icons';

import type { CompanyStatus } from '@/services/managers';

const props = defineProps<{
  status: CompanyStatus;
}>();

const { t } = useI18n();

const COLOR_BY_STATUS: Record<CompanyStatus, string> = {
  active: 'bg-green-25 text-green-600',
  in_analysis: 'bg-royal-25 text-royal-500',
  pending: 'bg-yellow-25 text-yellow-500',
  blocked: 'bg-red-25 text-red-600',
};

const ICON_BY_STATUS = {
  active: CheckCircleIcon,
  in_analysis: TimeInputClockIcon,
  pending: InactiveWarningIcon,
  blocked: CardBlockedPadlockIcon,
};

const colorClass = computed(() => COLOR_BY_STATUS[props.status]);
const icon = computed(() => ICON_BY_STATUS[props.status]);
</script>
